
import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { AppInfo } from "../../app/credentials";



@Component({
  selector: "page-about",
  templateUrl: "about.html"
})
export class AboutPage {
  public ver: string;

  constructor(public navCtrl: NavController) {

    this.ver = AppInfo.Version;
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts